import React from "react";
import { Redirect, withRouter } from "react-router-dom";
import { isPathAllowed } from "../../rbac/rbacAccess";

// Wraps the routed content. If RBAC is enabled and the current path is a
// role-gated screen the user is not allowed to open, redirect to the
// Unauthorized page; otherwise render children unchanged.
function RbacGuard({ location, children }) {
  const pathname = location && location.pathname ? location.pathname : "";

  if (pathname === "/app/unauthorized" || isPathAllowed(pathname)) {
    return children;
  }

  return <Redirect to="/app/unauthorized" />;
}

export default withRouter(RbacGuard);
